// extracted by mini-css-extract-plugin
export var gridHidden = "navigation-menu-mobile-dr-module--grid-hidden--a3e1b";
export var navigationMenuMobile = "navigation-menu-mobile-dr-module--navigation-menu-mobile--32298";